import React from 'react';
import ReactDOM from 'react-dom';
import { Panel } from './template.styles';
import { JRCPanelProps } from './template.type';

export function JRCPanel({ children, width, open = true }: JRCPanelProps) {
    const portalDiv = document.getElementById('jrc-container-panel');
    if (portalDiv) {
        return ReactDOM.createPortal(
            <Panel width={width} open={open}>
                {children}
            </Panel>,
            portalDiv,
        );
    }
    return <></>;
}
